import * as React from "react";
const SvgBack = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={19} viewBox="0 0 12 19" {...props}><path fill="currentColor" d="M12.024 16.823 4.565 9.545l7.459-7.278L9.754.052.024 9.546l9.73 9.494z" /></svg>;
export default SvgBack;